import React from 'react';
import { CssBaseline, Tooltip } from '@mui/material';
import Container from '@mui/material/Container';
import CustomInput from './../../../../../Components/CustomInput/CustomInput';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import CardContent from '@mui/material/CardContent';
import CardActions from '@mui/material/CardActions';
import IconButton from '@mui/material/IconButton';
import SaveRoundedIcon from '@mui/icons-material/SaveRounded';
import UseAutocomplete from './../../../../../Components/CustomInput/UseAutocompletes';
import axios from 'axios';
import { genpostURL, genpostURLTEST, genURL } from './../../../../../_getjson';
import Grid from '@mui/material/Grid';
import ReportGmailerrorredRoundedIcon from '@mui/icons-material/ReportGmailerrorredRounded';
import Snackbar from './../../../../../Components/Snackbar/Snackbar'
import Optionreport from './Optionreport';

import CheckCircleOutlineRoundedIcon from '@mui/icons-material/CheckCircleOutlineRounded';

import Addcategory from './Addcategory';
import DraggableDialog from './../../../../../Components/CustomDialogs/DraggableDialog';

export default function Addreport(props) {
    const [reportName, setReportName] = React.useState("")
    const [reportNameEn, setReportNameEn] = React.useState("")
    const [reportURL, setReportURL] = React.useState("")
    const [category, setCategory] = React.useState([])
    const [categoryID, setCategoryID] = React.useState("")

    // const [categorysub, setCategorysub] = React.useState([])
    // const [categorysubID, setCategorysubID] = React.useState("")

    //----------------------------alert ----------------------------
    const [color, setColor] = React.useState("")
    const [opensnackbar, setOpensnackbar] = React.useState(false)
    const [autoClose, setAutoClose] = React.useState(3600)
    const [messagealert, setMessagealert] = React.useState("")
    const [icon, setIcon] = React.useState("")

    // menuID
    const [menu, setMenu] = React.useState([])
    const [menuID, setMenuID] = React.useState("")
    //---------------------- option data ----------------------------------
    const [optionData, setOptiondata] = React.useState([])

    const [categorynamedata, setCategorynameData] = React.useState()
    const [categorysubnamedata, setCategorynamesubData] = React.useState()
    //----------------------------alert ----------------------------
    const [title, setTitle] = React.useState("")
    const [buttontxt, setButtontxt] = React.useState("")
    const [openModle, setOpenModle] = React.useState(false)
    const [typeModle, setTypeModle] = React.useState(false)


    const [defaultvaluecate, seDefaultvaluecate] = React.useState("")
    const [defaultvaluecatesub, seDefaultvaluecatesub] = React.useState("")
    React.useEffect(() => {
        getCategory()
        getMenu()
        return () => {
        }
    }, [])

    const getCategory = async () => {
        let url = "reportmanage/category?"
        let elementcategory = []
        // console.log("resdata getCategory", genpostURLTEST(url));
        await axios.get(genURL(url)).then(res => {
            // await axios.post(genpostURLTEST(url), parameter).then(res => {
            console.log("resdata getCategory", genURL(url), res.data);
            if (res.data.length > 0) {
                for (let index = 0; index < res.data.length; index++) {
                    if (res.data[index].catelevel > 0) {
                        elementcategory.push({ CODE: res.data[index].id, MYNAMETH: res.data[index].nameTH + "(l:" + res.data[index].catelevel + ")<" + res.data[index].mainrefnameth })
                    }
                }
            } else {
                setAddcategory(true)
            }
        }).catch(error => {
            console.log("resdata", error);
            // this.setState({ opensnackbar: true })
            // this.setState({ color: "warning" })
            // this.setState({ icon: ErrorIcon })
            // this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
            // this.setState({ openBackdrop: false })
        });
        await setCategory(elementcategory)

    }


    const getMenu = async () => {

        let urlmenu = `csmstrightmnu2/Getmenuid?`
        let elementmenu = []
        console.log("resdata url Getmenuid ", urlmenu, "Getmenu", genpostURL(urlmenu));
        await axios.get(genURL(urlmenu)).then(res => {
            // await axios.post(genpostURLTEST(url), parameter).then(res => {
            console.log("resdata Getmenuid", res.data);
            if (res.data.length > 0) {
                for (let index = 0; index < res.data.length; index++) {
                    elementmenu.push({ CODE: res.data[index].MENUID, MYNAMETH: res.data[index].MENUNAME })
                }
            }
        }).catch(error => {
            console.log("resdata Getmenuid", error);
            // this.setState({ opensnackbar: true })
            // this.setState({ color: "warning" })
            // this.setState({ icon: ErrorIcon })
            // this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
            // this.setState({ openBackdrop: false })
        });
        await setMenu(elementmenu)
    }
    const setvalue = async (e, type) => {
        console.log("e setvalue" + e[0].CODE);
        await setTypeModle(type)
        if (type == "category") {
            setCategoryID(e[0].CODE)
            if (e[0].CODE === 0) {
                await setCategorynameData(e[0].MYNAMETH)
                await setTitle("เพิ่มหมวดหมู่")
                await setButtontxt("ปิด")
                await setOpenModle(true)
            }
        }
        if (type == "menu") {
            setMenuID(e[0].CODE)
        }
    }
    const saveData = async () => {
        // console.log("save");
        if (reportName === "") {
            setMessagealert("กรุณาระบุชื่อรายงานด้วยครับ")
            setColor("warning")
            setOpensnackbar(true)
            setIcon(< ReportGmailerrorredRoundedIcon />)
            return
        }
        if (reportURL === "") {
            setMessagealert("กรุณาระบุลิงค์รายงานด้วยครับ")
            setColor("warning")
            setOpensnackbar(true)
            setIcon(< ReportGmailerrorredRoundedIcon />)
            return
        }

        if (categoryID === "") {
            setMessagealert("กรุณาระบุหมวดหมู่ด้วยครับ")
            setColor("warning")
            setOpensnackbar(true)
            setIcon(< ReportGmailerrorredRoundedIcon />)
            return
        }


        if (optionData.length < 1) {
            setMessagealert("กรุณาระบุเงื่อนไขรายงานอย่างน้อย 1 เงื่อนไข")
            setColor("warning")
            setOpensnackbar(true)
            setIcon(< ReportGmailerrorredRoundedIcon />)
            return
        }
        const parameter = new URLSearchParams();

        parameter.append("reportName", reportName.trim());
        parameter.append("reportNameEn", reportNameEn.trim());
        parameter.append("reportURL", reportURL.trim());
        parameter.append("categoryID", categoryID);
        parameter.append("menuID", menuID);
        parameter.append("userID", localStorage.getItem("Username"));
        let url = "/reportmanage/report?"
        // await axios.post(genpostURL(url), parameter).then(res => {
        await axios.post(genURL(url), parameter).then(res => {
            console.log("resdata", res.data);
            if (res.data.status === "success") {
                if (optionData.length > 0) {
                    let urloption = "/reportmanage/optionreport?"
                    const parameteroptionData = new URLSearchParams();
                    parameteroptionData.append("reportID", res.data.lastID);
                    parameteroptionData.append("optionData", JSON.stringify(optionData));
                    console.log("resdata option optionData", optionData);
                    axios.post(genURL(urloption), parameteroptionData).then(res => {
                        console.log("resdata option", res.data);
                        if (res.data.status === "success") {
                            setMessagealert("บันทึกสำเร็จ")
                            setColor("success")
                            setOpensnackbar(true)
                            setIcon(< CheckCircleOutlineRoundedIcon />)
                        }
                    })
                } else {
                    setMessagealert("บันทึกสำเร็จ")
                    setColor("success")
                    setOpensnackbar(true)
                    setIcon(< CheckCircleOutlineRoundedIcon />)
                }
                setTimeout(() => {
                    props.CloseDialog(false)
                }, 300);
            } else {
                // this.setState({ opensnackbar: true })
                // this.setState({ color: "warning" })
                // this.setState({ icon: ErrorIcon })
                // this.setState({ messagealert: "บันทึกข้อมูลไม่สำเร็จ" })
                // this.setState({ openBackdrop: false })
            }
        }).catch(error => {
            console.log("error" + error);
            // this.setState({ opensnackbar: true })
            // this.setState({ color: "warning" })
            // this.setState({ icon: ErrorIcon })
            // this.setState({ messagealert: "เกิดข้อผิดพลาด" + error })
            // this.setState({ openBackdrop: false })
        });
    }
    const OptionData = (val) => {
        setOptiondata(val)
    }

    const closedialog = async (e) => {
        setOpenModle(e)
        if (typeModle === "category") {
            await seDefaultvaluecate(null)
            await getCategory()
        } else if (typeModle === "categorysub") {
            await seDefaultvaluecatesub(null)
            await getCategorysub(categoryID)
        }
    }
    return (
        <>
            <br />
            <CssBaseline />
            <Container>
                <Card sx={{ minWidth: 275 }}>
                    <CardHeader
                        avatar={""}
                        action={
                            <IconButton aria-label="settings" onClick={e => saveData()}>
                                <SaveRoundedIcon sx={{ cursor: "pointer" }} />
                            </IconButton>
                        }
                        title=""
                        subheader=""
                    />
                    <CardContent>
                        <CustomInput label='ชื่อรายงาน(TH)' resData={e => { setReportName(e) }} inputType={"text"} defaultValue={""} id={"reportName"} />
                        <CustomInput label='ชื่อรายงาน(EN)' resData={e => { setReportNameEn(e) }} inputType={"text"} defaultValue={""} id={"reportNameEn"} />
                        <CustomInput label='URL รายงาน' resData={e => { setReportURL(e) }} inputType={"text"} defaultValue={""} id={"reportURL"}
                            placeholder={"flow.html?...=true"} />

                        <Grid container spacing={2} sx={{ marginTop: 0 }}>
                            <Grid item xs={12}>
                                <UseAutocomplete title="หมวดหมู่" id="category"
                                    datalist={category}
                                    valueReturn={e => setvalue(e, "category")}
                                    placeholder={""}
                                    defaultvalue={defaultvaluecate}
                                    adddataenable={true}
                                    activate={e => console.log(" category activate")}
                                />
                            </Grid>

                            {/* <Grid item xs={6}>
                                <UseAutocomplete title="หมวดหมู่ L2" id="categorysub"
                                    datalist={categorysub}
                                    valueReturn={e => setvalue(e, "categorysub")}
                                    placeholder={""}
                                    defaultvalue={defaultvaluecatesub}
                                    adddataenable={true}
                                    activate={e => console.log(" categorysub activate")}
                                />
                            </Grid> */}

                        </Grid>
                        <Grid container spacing={2}  >
                            <Grid item xs={12}>
                                <UseAutocomplete title="สำหรับเมนู" id="menu"
                                    datalist={menu}
                                    valueReturn={e => setvalue(e, "menu")}
                                    placeholder={""}
                                    activate={e => console.log(" menu activate")}

                                />
                            </Grid>
                        </Grid>
                        <>
                            <hr></hr>
                            <p>เงื่อนไขรายงาน</p>
                            <Optionreport Dataintable={e => OptionData(e)} Dataintableremove={e => console.log(e)} />
                        </>
                    </CardContent>
                    <CardActions disableSpacing>
                    </CardActions>
                </Card>
            </Container>
            <DraggableDialog open={openModle} title={title} buttontxt={""} closedialog={_ => setOpenModle(false)}>
                {typeModle === "category" ?
                    <Addcategory CloseDialog={e => closedialog(e)} AddData={categorynamedata} /> : <></>
                }
            </DraggableDialog>
            <Snackbar place="br"
                color={color}
                icon={icon}
                autoClose={autoClose}
                message={messagealert}
                open={opensnackbar}
                closeNotification={() => { setOpensnackbar(false) }}
                close />
        </>
    );
}